__turbopack_context__.v({
  "permissionSpinner": "AssetDeleteModal-module__htbvKG__permissionSpinner",
});
